import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/home/index.vue';
import SolutionManual from '../views/solution-manual/index.vue';
import PrisonSolution from '@/views/prison-solution/index.vue';
import EducationSolution from '@/views/education-solution/index.vue';
import SchoolSolution from '@/views/school-solution/index.vue';
import PoliceSolution from '@/views/police-solution/index.vue';
import UniversityEvaluation from '@/views/university-evaluation/index.vue';
import TrafficPsychology from '@/views/traffic-psychology/index.vue';

Vue.use(VueRouter); // 必须调用此方法安装插件

const routes = [{
		path: "/",
		redirect: "/home"
	},
	{
		path: "/home",
		name: "home",
		component: Home,
		meta: {
			title: "首页",
			isLink: "",
			isHide: false,
			isKeepAlive: true,
			isAffix: true,
			isIframe: false,
			roles: ["administrator", "common"],
			icon: "fas fa-home"
		}
	},
	{
		path: "/solution-manual",
		name: "solutionManual",
		component: SolutionManual,
		meta: {
			title: "心理测评SaaS系统产品手册",
			isLink: "",
			isHide: false,
			isKeepAlive: true,
			isAffix: false,
			isIframe: false,
			roles: ["administrator", "common"],
			icon: "fas fa-book"
		}
	},
	{
		path: "/prison-solution",
		name: "prisonSolution",
		component: PrisonSolution,
		meta: {
			title: "看守所监狱心理测评与心理矫治管理系统",
			isLink: "",
			isHide: false,
			isKeepAlive: true,
			isAffix: false,
			isIframe: false,
			roles: ["administrator", "common"],
			icon: "fas fa-shield-alt"
		}
	},
	{
		path: "/education-solution",
		name: "educationSolution",
		component: EducationSolution,
		meta: {
			title: "教育局心理测评系统建设方案",
			isLink: "",
			isHide: false,
			isKeepAlive: true,
			isAffix: false,
			isIframe: false,
			roles: ["administrator", "common"],
			icon: "fas fa-school"
		}
	},
	{
		path: "/school-solution",
		name: "schoolSolution",
		component: SchoolSolution,
		meta: {
			title: "中小学心理测评系统方案",
			isLink: "",
			isHide: false,
			isKeepAlive: true,
			isAffix: false,
			isIframe: false,
			roles: ["administrator", "common"],
			icon: "fas fa-heart"
		}
	},
	{
		path: "/police-solution",
		name: "policeSolution",
		component: PoliceSolution,
		meta: {
			title: "公安民警心理测评系统完整实施方案",
			isLink: "",
			isHide: false,
			isKeepAlive: true,
			isAffix: false,
			isIframe: false,
			roles: ["administrator", "common"],
			icon: "fas fa-shield"
		}
	},
	{
		path: "/university-evaluation",
		name: "universityEvaluation",
		component: UniversityEvaluation,
		meta: {
			title: "大学心理测评实施方案",
			isLink: "",
			isHide: false,
			isKeepAlive: true,
			isAffix: false,
			isIframe: false,
			roles: ["administrator", "common"],
			icon: "fas fa-university"
		}
	},
	{
		path: "/traffic-psychology",
		name: "trafficPsychology",
		component: TrafficPsychology,
		meta: {
			title: "交通驾驶员心理测评解决方案",
			isLink: "",
			isHide: false,
			isKeepAlive: true,
			isAffix: false,
			isIframe: false,
			roles: ["administrator", "common"],
			icon: "fas fa-car"
		}
	}
];

const router = new VueRouter({
	mode: 'history', // 可选：使用 HTML5 History 模式
	routes
});

export default router;